/* eslint strict: "off" */

module.exports = (function () {
	return this;
}());



// WEBPACK FOOTER //
// ./node_modules/es5-ext/global.js